import { GlobalSearchParams } from '../../../modules/global-search/globalSearch.types';

export const serializeEntityTypes = (entityTypes: GlobalSearchParams['entityTypes']) =>
  entityTypes && entityTypes.length > 0 ? entityTypes.join(',') : undefined;
